import { FC } from 'react'
import { SvgProps } from './svgProps'

const UnderwearMenIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    fill={color || '#000000'}
    width={width || '32'}
    height={height || '32'}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
  >
    <g transform="translate(1 1)">
      <g>
        <g>
          <circle cx="75.8" cy="161.035" r="8.533" />
          <circle cx="127" cy="161.035" r="8.533" />
          <circle cx="178.2" cy="161.035" r="8.533" />
          <circle cx="229.4" cy="161.035" r="8.533" />
          <circle cx="280.6" cy="161.035" r="8.533" />
          <circle cx="331.8" cy="161.035" r="8.533" />
          <circle cx="383" cy="161.035" r="8.533" />
          <circle cx="434.2" cy="161.035" r="8.533" />
          <path
            d="M485.4,118.368H24.6c-14.142,0-25.6,11.458-25.6,25.6v51.2v153.6c0,14.142,11.458,25.6,25.6,25.6h128h40.403l2.625,1.498
				c36.529,20.874,81.322,21.009,117.971,0.424c0.255-0.134,0.504-0.271,0.772-0.424c0.002-0.001,0.003-0.002,0.005-0.003
				l2.621-1.495H357.4h128c14.142,0,25.6-11.458,25.6-25.6v-153.6v-51.2C511,129.826,499.542,118.368,485.4,118.368z
				 M16.067,143.968c0-4.716,3.817-8.533,8.533-8.533h460.8c4.716,0,8.533,3.817,8.533,8.533v42.667h-153.6H169.667h-153.6V143.968z
				 M144.877,357.302h-5.809L16.067,234.3v-30.599h144.171L147.66,329.475L144.877,357.302z M87.868,357.302L16.067,285.5v-27.064
				l98.865,98.865H87.868z M16.067,348.768v-39.132l47.665,47.665H24.6C19.883,357.302,16.067,353.485,16.067,348.768z
				 M204.091,361.046l-4.595-2.622c-1.288-0.735-2.746-1.122-4.229-1.122h-33.237l15.36-153.6h155.222l2.469,24.693l5.296,52.959
				c-24.288,4.404-42.709,25.641-42.709,51.201v32.708C267.789,378.929,232.938,377.529,204.091,361.046z M314.733,357.302v-24.747
				c0-16.702,11.697-30.666,27.348-34.151l5.89,58.897H314.733z M493.933,348.768c0,4.716-3.817,8.533-8.533,8.533H365.123
				l-15.36-153.6h144.171V348.768z"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default UnderwearMenIcon
